import { Message, ApiMessage } from './text-messages.types';

export const convertApiMessageToMessage = (apiMessage: ApiMessage): Message => {
  if (!apiMessage) {
    throw new Error('Cannot convert undefined or null message');
  }

  return {
    id: apiMessage.id?.toString() || '',
    content: apiMessage.message || apiMessage.body || '',
    sender: apiMessage.direction === 'inbound' ? 'applicant' : 'recruiter',
    timestamp: apiMessage.created_at ? new Date(apiMessage.created_at) : new Date(),
    status: apiMessage.status === 'sent' ? 'sent' : 'failed',
    messageSid: apiMessage.message_sid,
    fromNumber: apiMessage.from_number,
    toNumber: apiMessage.to_number,
    direction: apiMessage.direction,
    readByEmployer: apiMessage.read_by_employer || false,
  };
}; 